import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { UserList, UserProfile, CreateUser } from './components';

export const UsersPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<UserList />} />
      <Route path="create" element={<CreateUser />} />
      <Route path=":userId" element={<UserProfile />} />
    </Routes>
  );
};
